
  import { defineComponent } from 'vue';

  import FilterDetails from '@/common/components/redesigned/Filter/FilterDetails.vue';

  export default defineComponent({
    name: 'FilterDetailsVed',
    components: {
      FilterDetails,
    },
  });
